import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { GlobalReducer } from '../global/store/global.reducer';
import { UserState } from '../user/user.model';
import { GlobalState } from '../global/global.model';
import { UserReducer } from '../user/store/user.reducer';
import { AuthState } from '../auth/auth.model';
import { AuthReducer } from '../auth/store/auth.reducer';

export interface State {
    global: GlobalState;
    user: UserState;
    auth: AuthState;
}

export const reducers: ActionReducerMap<State> = {
    global: GlobalReducer,
    user: UserReducer,
    auth: AuthReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
